import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Start from "./screens/Start";
import LocaleSelection from "./screens/LocaleSelection";
import UploadDocuments from "./screens/UploadDocuments";
import ScanInstructions from "./screens/ScanInstructions";
import FaceScan from "./screens/FaceScan";
import ScanResult from "./screens/ScanResult";
import NotFound from "./screens/NotFound";

const router = createBrowserRouter([
  { path: "start", element: <Start /> },
  { path: "locale-selection", element: <LocaleSelection /> },
  { path: "upload-documents", element: <UploadDocuments /> },
  { path: "scan-instructions", element: <ScanInstructions /> },
  { path: "face-scan", element: <FaceScan /> },
  { path: "scan-result", element: <ScanResult /> },
  { path: "*", element: <NotFound /> },
]);

const App = () => <RouterProvider router={router} />;

export default App;
